import 'twin.macro'

import CardLimitIcon from 'assets/icons/CardLimitIcon'
import { Button } from 'components/UI/button/button'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useGetPrepaidGeneralInfoQuery } from 'redux/api/buy-card.api'
function CardlimitContainer({ onClose, cardLimit }: { onClose: () => void; cardLimit: number }) {
  const { t } = useTranslation()
  return (
    <div tw='flex flex-col items-center gap-5 text-center'>
      <CardLimitIcon />
      <Title variant='bold'>{t('cardLimit.title', { ns: 'badcases' })}</Title>
      {/* <SubTitle>{t('cardLimit.desc', { ns: 'badcases', limit: cardLimit })}</SubTitle> */}
      <Button variant='gradient' onClick={onClose}>
        {t('cardLimit.close', { ns: 'badcases' })}
      </Button>
    </div>
  )
}

export default CardlimitContainer
